import { render, staticRenderFns } from "./verifyFail.vue?vue&type=template&id=0377bb2b"
import script from "./verifyFail.vue?vue&type=script&lang=js"
export * from "./verifyFail.vue?vue&type=script&lang=js"
import style0 from "./verifyFail.vue?vue&type=style&index=0&id=0377bb2b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports